import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/api/auth.service';
import { Store } from '@ngrx/store';
import { UserActions } from '../states/auth/auth.actions';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private _auth: AuthService,
    private _router: Router,
    private _store: Store
  ) {}
  canActivate(): boolean {
    if (this._auth.isLoggedOut()) {
      this._store.dispatch(UserActions.userLogout());
      this._router.navigate(['/auth/login']);
      return false;
    }
    return true;
  }
}
